import React from 'react'

import EditPostContainer, {
	CommonContainerProps,
} from 'containers/EditPostContainer'
import InfoWithLink from 'components/Text/InfoWithLink'
import { formatDate, formatFullLocation, formatCertificates } from 'utils'

import { EditedJob } from 'components/EditJob'
import {
	Container,
	InfoRow,
	Divider,
	EmailAddressContainer,
	EditIcon,
	UpdateButton,
	Availability,
	EmailInput
} from './ConfirmDetails.style'

interface ConfirmDetailsProps extends CommonContainerProps<any> {
	editedJobPost: EditedJob

	onPosition: () => any
	onTitleDescription: () => any
	onLocation: () => any
	onDates: () => any
	onAvailability: () => any
	onRequirements: () => any
	onChangeEmail: (email?: string) => any
}

interface ConfirmDetailsState {
	editable: boolean
	notificationEmail?: string
}

export default class ConfirmDetails extends React.Component<ConfirmDetailsProps,
	ConfirmDetailsState> {
	constructor(props: ConfirmDetailsProps) {
		super(props)
		this.state = {
			editable: false,
			notificationEmail: this.props.editedJobPost.notificationEmail,
		}
	}

	handleUpdate(event: any) {
		let value = event.target.value
		this.setState({ notificationEmail: value })
	}

	onEdit = () => {
		this.setState({ editable: true })
	}

	handleContentEditable = () => {
		this.setState({ editable: !this.state.editable })
		this.props.onChangeEmail(this.state.notificationEmail)
	}

	render() {
		const { editedJobPost } = this.props
		return (
			<EditPostContainer
				progressValue={88}
				title='Confirm Details'
				{...this.props}
				isNextAvailable={true}
			>
				<Container>
					<InfoWithLink
						title='Position'
						text={editedJobPost.position?.text as string}
						onClick={this.props.onPosition}
					/>
					<InfoWithLink
						title='Title'
						text={editedJobPost.title as string}
						onClick={this.props.onTitleDescription}
					/>
					<InfoWithLink
						title='Description'
						description={true}
						text={editedJobPost.description as string}
						onClick={this.props.onTitleDescription}
					/>
					<InfoWithLink
						title='Location'
						text={formatFullLocation(editedJobPost.location)}
						onClick={this.props.onLocation}
					/>
					<InfoRow>
						<InfoWithLink
							title='Start Date'
							text={`${formatDate(editedJobPost.startDate as Date)} ${editedJobPost.approxStart ? 'Approximate': ''}`}
							onClick={this.props.onDates}
						/>
						{
							editedJobPost.endDate && (
								<InfoWithLink
									style={{ marginLeft: 20 }}
									title='End Date'
									text={`${formatDate(editedJobPost.endDate as Date)} ${editedJobPost.approxEnd ? 'Approximate': ''}`}
									onClick={this.props.onDates}
								/>
							)
						}
					</InfoRow>
					<Availability
						title='Availability'
						availability={editedJobPost.availability as Array<number>}
						onClick={this.props.onAvailability}
					/>
					<InfoWithLink
						title='Minimum Experience'
						text={`${editedJobPost.requirement?.text} ${formatCertificates(editedJobPost.isOrtho, editedJobPost.isRestorative)}`}
						onClick={this.props.onRequirements}
					/>
					<Divider />
					<EmailAddressContainer>
						Notification of new candidates <br/> will be sent to
						<EmailInput 
						type="email" 
						className={'email' + (this.state.editable ? ' editable' : '')}
						onChange={event => this.handleUpdate(event)}
						value={this.state.notificationEmail}
						onClick={!this.state.editable ? this.onEdit : undefined}
						width={this.state.notificationEmail?.length as number}
						/>
						<UpdateButton onClick={this.handleContentEditable}>
							{this.state.editable ? (
								<>Save</>
							) : (
								<>
									<EditIcon /> Update
								</>
							)}
						</UpdateButton>
					</EmailAddressContainer>
				</Container>
			</EditPostContainer>
		)
	}
}
